import React from 'react'

export default function SitePlanFilters({ floorplanState, setFloorplanState, planTypeOptions = [] }) {
  const { currentFilterOption } = floorplanState

  const getOptionValue = option => {
    if (typeof option === 'object' && option !== null) {
      return option.value
    }

    return option
  }

  const getOptionLabel = option => {
    if (typeof option === 'object' && option !== null) {
      return option.label || option.value
    }

    return option
  }

  const handleFilterSelect = option => {
    const isActive = getOptionValue(currentFilterOption) === getOptionValue(option)

    setFloorplanState({
      currentFilterOption: isActive ? null : option
    })
  }

  return (
    <div className="site-plan-filters">
      {planTypeOptions.map(option => {
        const optionValue = getOptionValue(option)
        const isSelected = getOptionValue(currentFilterOption) === optionValue

        return (
          <button
            key={optionValue}
            type="button"
            className={`btn site-plan-filter-option ${isSelected ? 'active' : ''}`}
            onClick={() => handleFilterSelect(option)}
          >
            {getOptionLabel(option)}
          </button>
        )
      })}
    </div>
  )
}